<template>
  <div class="" v-if="cartSize > 0">
   <button class="mxr-close-btn" @click="closeSummary"><i class="zmdi zmdi-close"></i></button>
   <table class="unstriped stack">
    <thead>
      <tr>
        <th width="80"></th>
        <th></th>
        <!-- <th class="text-center">Taille</th> -->
        <th>Prix</th>
        <th class="text-center">Quantité</th>
        <th>Total</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(product, index) in cart">
        <td class="align-small-pic"><img :src="product.image" alt="" width="50"></td>
        <td class="align-small-name">
          <!-- <small class="mxr-product__ref">Ref : {{ product.id }}</small> -->
          <div class="mxr-product__title">{{ product.name }}</div>
          <div>Taille {{ product.size }}</div>
        </td>
        <!-- <td class="text-center">{{ product.size }}</td> -->
        <td class="align-small-price"><span class="price-label hide-for-large">Prix : </span> {{ product.price }}&nbsp;€</td>
        <td class="align-small-qty text-center">
          <button class="button-qty" @click="decrement(index)"><i class="zmdi zmdi-minus"></i></button>
          {{ product.quantity }}
          <button class="button-qty" @click="increment(index)"><i class="zmdi zmdi-plus"></i></button>
        </td>
        <td class="align-small-total"><span class="price-label hide-for-large">Total : </span>{{ (product.price * product.quantity).toFixed(2) }}&nbsp;€</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="4" class="text-right">Total</td>
        <td>{{ total }}&nbsp;€</td>
      </tr>
    </tfoot>
  </table>
  <div class="cart-nav">
    <a :href="exportURL" class="button cta-btn">Continuer sur Decathlon.fr</a>
  </div>
</div>
</template>

<script>
  import borders from '@/components/Borders';
  import { mapGetters } from 'vuex';

  export default {
    name: 'cart',
    components: {
      borders,
    },
    data() {
      return {
      };
    },
    methods: {
      increment(id) {
        this.$store.commit('incrementQty', id);
        this.setCookie();
      },
      decrement(id) {
        this.$store.commit('decrementQty', id);
        this.setCookie();
      },
      setCookie() {
        this.$cookie.set('basket', JSON.stringify(this.$store.state.cart), 30);
      },
      closeSummary() {
        this.$parent.$emit('closeSummary');
      },
    },
    computed: {
      ...mapGetters([
        'cartExport',
        'cart',
        'cartSize',
      ]),
      total() {
        let totalprice = 0;
        let i = 0;
        for (i; i < this.cart.length; i += 1) {
          totalprice += parseFloat(this.cart[i].quantity * this.cart[i].price, 10);
        }
        return totalprice.toFixed(2);
      },
      exportURL() {
        const obj = {
          basket: {
            identifier: 'DressYourRun',
            products: this.cartExport,
          },
        };
        return `https://www.decathlon.fr/fr/importExternalBasket?jsonString=${encodeURIComponent(JSON.stringify(obj))}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mxr-close-btn {
    position: absolute;
    top: 0;
    right: 0;
    padding: rem-calc(18 22);
    color: $medium-gray;
    font-size: rem-calc(22);
    @include breakpoint(medium) {
      font-size: rem-calc(28);
    }
  }
  .cart-nav {
    background: $white;
    position: fixed;
    width: 100%;
    padding: rem-calc(16 0 0 0);
    bottom: rem-calc($nav-height-sm);
    @include breakpoint(medium) {
      bottom: rem-calc($nav-height);
    }
    &:before {
      height: rem-calc(50);
      background: linear-gradient(to bottom, rgba(white,0) 0%,rgba(white,1) 100%); ;
      content: '';
      position: absolute;
      width: 100%;
      bottom: 100%;
      right: 0;
      left: 0;
    }
  }
  .mxr-product__title {
    font-weight: $global-weight-bold;
  }
  .mxr-product__ref {
    font-size: rem-calc(11);
    color: darken($blue-gray, 20%);
  }
  thead th {
    text-transform: uppercase;
    font-weight: normal;
    font-size: rem-calc(11);
    color: darken($blue-gray, 20%);
    letter-spacing: .1em;
  }

  @include breakpoint(medium down) {
    tbody tr {
      display: flex;
      flex-wrap: wrap;
      border-bottom: rem-calc(1) solid lighten($light-gray, 6%);

      .align-small-pic {
        flex: 16%;
      }
      .align-small-name {
        flex: 82%
      }

      .align-small-qty {
        flex: 44%
      }
      .align-small-price, .align-small-total {
        flex: 28%;

        .price-label {
          text-transform: uppercase;
          font-size: rem-calc(10);
          color: darken($blue-gray, 20%);
          display: block;
        }
      }
      .align-small-total {
        text-align: right;
      }
    }
  }

  .button-qty {
    border: $input-border !important;
    margin: rem-calc(0 4);
    padding: rem-calc(6 9);
    transition: $input-transition;

    &:focus {
      border: $input-border-focus !important;
    }
  }
</style>



// WEBPACK FOOTER //
// CartSummary.vue?c94e5112